import React from 'react';
import './search.scss';
import {InputField} from '@elixir/components';
import PropTypes from 'prop-types';

export class Search extends React.Component {

    constructor (props) {
        super(props);
    }

    render () {
        const {
            onValueChange,
            searchText,
            placeholder
        } = this.props;

        return (
            <div className="searchComponentContainer ">
                <InputField
                    className="searchComponent"
                    placeholder={placeholder}
                    id="filterInput"
                    icon="search"
                    onValueChange={onValueChange}
                    value={searchText}/>
            </div>
        );
    }
}

Search.propTypes = {
    searchText: PropTypes.string,
    placeholder: PropTypes.string,
    onValueChange: PropTypes.func
};

